import bill from '../../../assets/icons/bill.svg';
import close from '../../../assets/icons/close.svg';
import dispatched from '../../../assets/icons/dispatched.svg';
import dispatchedActive from '../../../assets/icons/dispatched-active.svg';
import enroute from '../../../assets/icons/enroute.svg';
import enrouteActive from '../../../assets/icons/enroute-active.svg';
import delivered from '../../../assets/icons/delivered.svg';
import deliveredActive from '../../../assets/icons/delivered-active.svg';
import info from '../../../assets/icons/info.svg';
import minus from '../../../assets/icons/minus.svg';
import phone from '../../../assets/icons/phone.svg';
import picked from '../../../assets/icons/picked.svg';
import pickedActive from '../../../assets/icons/picked-active.svg';
import plus from '../../../assets/icons/plus.svg';
import received from '../../../assets/icons/received.svg';
import receivedActive from '../../../assets/icons/received-active.svg';
import timer from '../../../assets/icons/timer.svg';

export const ICONS = {
  bill,
  close,
  delivered,
  deliveredActive,
  dispatched,
  dispatchedActive,
  enroute,
  enrouteActive,
  info,
  minus,
  phone,
  picked,
  pickedActive,
  plus,
  received,
  receivedActive,
  timer,
};



// WEBPACK FOOTER //
// src/components/atoms/Icon/index.jsx